import { Component, ComponentFactoryResolver} from '@angular/core';
import { IonicPage, ModalController, NavController, ToastController, NavParams, AlertController, ViewController, App } from 'ionic-angular';
import { CalendarModal, CalendarModalOptions, CalendarResult } from 'ion2-calendar';
import { RestProvider } from '../../providers/rest/rest';
import { DataProvider } from '../../providers/data/data';
import { HttpClient} from '@angular/common/http';
import { TaskPage } from '../task/task';
import { UserRequestPage } from '../userRequest/userRequest';
import { of } from 'rxjs/observable/of';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { raceStatic } from 'rxjs/operator/race';


@IonicPage()
@Component({
  selector: 'page-dashboard',
  templateUrl: 'dashboard.html',
})
export class DashboardPage {
  private userId: any;
  private date: any;
  private type: any;
  private companyId: any;
  private TimeCard = [];
  private Dates = [];
  private empty_dates = [];
  myValue1: boolean;
  myValue2: boolean;
  value: any;
  private UndsenDays = 0;
  private ajilsanDays = 0;
  private jobCoreTime = 0;
  private undsenTime = 0;
  private ajillasanTime = 0.0;
  private iluuTime = 0.0;
  private dateBegin: any;
  private dateEnd: any;
  private email: any;
  private password: any;
  private ajillajEhelsen: any;
  private defYear = 0;
  private workYear = 0;
  private yearDay : any;
  private allday: any;
  private cday: any;
  private alltime: any;
  private utime: any;
  private uday: any;
  private tuluv1 = false;
  private emptyDates = [];
  private huselt = [];
  private times = [];
  private countRequest = 0;
  private countRequest1 = 0;
  disabled: boolean = false;
  private amraltDateCount = 0;
  private chuluuDateCount = 0;
  private chuluuDateCountDay = 0;
  private chuluuDateCountDayAM = 0;
  private chuluuDateCountDayPM = 0;
  private origAllDay = 0;
  private timesDates = [];
  private request = [];
  private dates = [];
  private datesExit = [];
  private everyMonthChuluuButenMonthStart = 0;
  private everyMonthChuluuHagas = [];
  private everyMonthChuluuButen = [];
  public allRequestDays = [];
  public MonthTotalDay = [];
  public AllButenChuluu = [];
  public chuluuDates = [];
  public nowDate: any;
  private startT = '09:00';
  private todayStartTime: any;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    private data: DataProvider,
    private toastCtrl: ToastController,
    ) {

  }
  ionViewDidEnter(): void {
    document.getElementById('mainmenu').style.visibility = 'visible';
    document.getElementById('backmenu').style.display = 'none';
    document.getElementById('mainHeader').style.display = 'block';
    document.getElementById('backFrom').innerText = '';
    this.data.currentTabName = 'Цаг бүртгэл';
  }
  ionViewDidLoad() {
    this.companyId = this.data.companyId;
    if(this.navParams.get('item')) {
      this.userId = this.navParams.get('item').user_id;
      this.data.userIditem = this.userId;
      this.data.userNameOther = this.navParams.get('item').firstname;
      this.data.imageOther = this.navParams.get('item').image;
    } else {
      this.userId = this.data.userId;
      this.data.userNameOther = null;
      this.data.imageOther = null;
    }
    this.dateVal();
  }
  
  dateVal() {
    const now = new Date();
    let nowdate = now.getFullYear().toString() + '-' +
        ('0' + (now.getMonth() + 1).toString()).slice(-2) + '-' +
        ('0' + now.getDate().toString()).slice(-2);
    this.nowDate = nowdate;
    let defYear = now.getFullYear();
    if(this.data.workYearStart != null) {
      this.workYear = defYear - parseInt(this.data.workYearStart.substring(0, 4));
    }
    //console.log(this.data.work_start_in.substring(0.4));
    this.rest.Dates(this.companyId).subscribe(res => {
      this.Dates = res;
      for(let i = 0; i < this.Dates.length;i++) {
        if(this.Dates[i].begin_day <= nowdate && this.Dates[i].end_day >= nowdate) {
          this.date = this.Dates[i].id;
        }
      }
      this.getTimeCard();
    });
  }
  
  tablesToExcel(name: any, id: any) {
    (window as any).tablesToExcel(id, name);
  }


  setTimeVerify(){
    this.allday = this.UndsenDays + "";
    this.uday = this.ajilsanDays + "";
    this.cday = this.jobCoreTime + "";
    this.alltime = this.undsenTime + "";
    this.utime = this.ajillasanTime + "";
    this.rest.Batalgaajuulalt(this.userId, this.date, this.allday, this.cday, this.uday,  this.alltime, this.utime).subscribe(res => {
      if(res == null) {
        this.myValue1 = false;
        this.myValue2 = false;
        this.showToast1('Сар дуусаагүй байна!!!');
      } else if(res.msg == 'ok') {
        this.showToast('Амжилттай баталгаажууллаа.');
      } else {
        this.myValue1 = false;
        this.myValue2 = false;
        this.showToast1('Сар дуусаагүй байна!!!');
      }
      this.getTimeCard();
  });
}



setDateSelect() {
  const now = new Date();
  let nowdate = now.getFullYear().toString() + '-' +
        ('0' + (now.getMonth() + 1).toString()).slice(-2) + '-' +
        ('0' + now.getDate().toString()).slice(-2);
  for(let i = 0; i < this.Dates.length;i++) {
    if(this.Dates[i].begin_day <= nowdate && this.Dates[i].end_day >= nowdate) {
      this.date = this.Dates[i].id;
    }
  }
}

  getTimeCard() {
    this.UndsenDays = 0;
    this.ajilsanDays = 0;
    this.jobCoreTime = 0;
    this.undsenTime = 0;
    this.ajillasanTime = 0.0;
    this.iluuTime = 0.0;
    this.yearDay = 0;
    this.countRequest = 0;
    this.countRequest1 = 0;
    this.amraltDateCount = 0;
    this.timesDates = [];
    this.request = [];
    this.dates = [];
    this.datesExit = [];
    this.chuluuDateCount = 0;
    this.everyMonthChuluuButenMonthStart = 0;
    this.chuluuDateCountDayAM = 0;
    this.chuluuDateCountDayPM = 0;
    this.everyMonthChuluuHagas = [];
    this.everyMonthChuluuButen = [];
    this.AllButenChuluu = [];
    this.chuluuDateCountDay = 0;
    this.MonthTotalDay = [];
    this.todayStartTime = 0;
    const now = new Date();
    let nowdate = now.getFullYear().toString() + '-' +
        ('0' + (now.getMonth() + 1).toString()).slice(-2) + '-' +
        ('0' + now.getDate().toString()).slice(-2);
    this.rest.TimeCard(this.userId, this.date, this.companyId).subscribe(res => {
      this.TimeCard = res;
      this.emptyDates = res.empty_dates;      
      for(let i = 0; i < res.times.length; i++) {
        this.data.timesInfoShare = res.times;
        // console.log(this.data.timesInfoShare);
        if (res.times[i].holiday == 0) {
          this.UndsenDays++;
          this.undsenTime = this.UndsenDays * 8;
        }

        if (res.times[i].coreTime == 1) {
          this.jobCoreTime++;
        }

        this.iluuTime = this.iluuTime + parseFloat(res.times[i].iluuTime);

        if (res.times[i].date == nowdate){
          this.data.workTime = res.times[i].workTime;
          this.timesDates.push(res.times);
          this.todayStartTime = res.times[i].startTime;
        }
        if (parseInt(this.data.type) != 2) {
          const now = new Date();
          let agoDate = now.getFullYear().toString() + '-' +
              ('0' + (now.getMonth() + 1).toString()).slice(-2) + '-' +
              ('0' + (now.getDate() - 1).toString()).slice(-2);
          const now1 = new Date();
          let agoDate2 = now1.getFullYear().toString() + '-' +
              ('0' + (now1.getMonth() + 1).toString()).slice(-2) + '-' +
              ('0' + (now1.getDate() - 2).toString()).slice(-2);
          if(res.times[i].date == agoDate){
            if(res.times[i].holiday == '0'){
              if(res.times[i].workTime > 8){
                this.showToast1('Илүү цагын хүсэлтээ илгээнэ үү!!!');
              }
            }
          } else if(res.times[i].holiday == '1'){
            if(res.times[i].date == agoDate2){
              if(res.times[i].workTime > 8){
                this.showToast1('Илүү цагын хүсэлтээ илгээнэ үү!!!');
              }
            }
          }
        }
        if(res.times[i].startTime != null) {
          this.ajilsanDays++;
          if(res.times[i].workTime != null) {
            this.ajillasanTime = this.ajillasanTime + parseFloat(res.times[i].workTime);
          }
        }
        if(res.chuluu.length > 0) {
          for(let chulu = 0; chulu < res.chuluu.length; chulu++) {
            if(res.times[i].startTime == null && res.times[i].endTime == null) {
              if(res.chuluu[chulu].forgot_date > res.times[i].date ||
                res.times[i].date >= res.chuluu[chulu].end_date && res.chuluu[chulu].holiday == 0) {
                  let ccc = 0;
                  for(let ii=0;ii<this.dates.length;ii++) {
                    if(this.dates[ii].date == res.times[i].date) {
                      ccc++;
                    }
                  }
                  if(ccc == 0) {
                    this.dates.push({date: res.times[i].date});
                  }
                }
            }
            if(res.times[i].startTime == null && res.times[i].endTime == null) {
              if(res.chuluu[chulu].forgot_date > res.times[i].date ||
                res.times[i].date >= res.chuluu[chulu].end_date) {
                  let ccc = 0;
                  for(let jj=0;jj<this.datesExit.length;jj++) {
                    if(this.datesExit[jj].date == res.times[i].date) {
                      ccc++;
                    }
                  }
                  if(ccc == 0) {
                    this.datesExit.push({date: res.times[i].date});
                  }
                }
            }
            for(let ii=0;ii<this.dates.length;ii++) {
              for(let jj=0;jj<this.datesExit.length;jj++) {
                if(this.dates[ii].date == this.datesExit[jj].date && this.datesExit[jj].user_id == this.dates[ii].user_id) {
                  this.dates.splice(ii, 1);
                }
              }
            }
          }
        }        
      }
      if(res.empty_dates.length > 0) {
        if(res.chuluu.length > 0) {
          for(let i=0; i<res.chuluu.length; i++) {
            for(let j=0; j<res.empty_dates.length; j++) {
              if(res.times[i].startTime == null && res.times[i].endTime == null && res.times[i].holiday == 0) {
                this.showToast2('Та дараах өдрүүдэд цагаа дараагүй байна. Шалгаад цагын хүсэлтээ илгээнэ үү!!!\n' + res.empty_dates);
                // if(res.chuluu[i].forgot_date > res.empty_dates[j] && res.chuluu[i].end_date >= res.empty_dates[j]) {  
                //   console.log(res.empty_dates[j])
                //   this.showToast2('Та дараах өдрүүдэд цагаа дараагүй байна. Шалгаад цагын хүсэлтээ илгээнэ үү1!!!\n' + res.empty_dates[j]);                  
                // }
              }              
            }
          }
        } else {
          let qq = '';
          for(let i = 0; i < this.emptyDates.length; i++) {
            qq = qq + this.emptyDates[i] +',  ';
          }  
          this.showToast2('Та дараах өдрүүдэд цагаа дараагүй байна. Шалгаад цагын хүсэлтээ илгээнэ үү!!!\n' + qq);
        }
      }


      this.dateBegin = res.times[0].date;
      this.dateEnd = res.times[res.times.length - 1].date;
      this.data.dateBegin = this.dateBegin;
      this.data.dateEnd = this.dateEnd;
      this.setSelectdate();
      // COUNT
      // for(let i = 0; i < res.time_types.length; i++) {
        this.rest.GetRequest(this.data.userId, this.date, "1").subscribe(res => {
          this.huselt = res.huselt;
          for(let i = 0; i < this.huselt.length; i++) {
            if(this.huselt[i].is_solved == 0){
              this.countRequest = this.countRequest + 1;
            } else if(this.huselt[i].is_solved == 1) {
              this.countRequest1 = this.countRequest1 + 1;
            }
            this.request.push(res.huselt);
            //if(res.huselt != null && res.huselt[i].type_id == 4){
             // for(let i = 0; i < this.TimeCard.length; i++){
             //   if(this.TimeCard[i].times == res.huselt[i].forgot_date){
              //    if(this.ajillasanTime > 8){
              //      this.showToast1('Илүү цагийн хүсэлтээ илгээнээ үү!!!');
               //   }
               // }
             // }
           // }            
          }
          this.rest.GetRequest(this.data.userId, this.date, "2").subscribe(res => {
            this.huselt = res.huselt;
            for(let i = 0; i < this.huselt.length; i++) {
              if(this.huselt[i].is_solved == 0){
                this.countRequest = this.countRequest + 1;
              } else if(this.huselt[i].is_solved == 1) {
                this.countRequest1 = this.countRequest1 + 1;
              }
              this.request.push(res.huselt);
            }
            this.rest.GetRequest(this.data.userId, this.date, "3").subscribe(res => {
              this.huselt = res.huselt;
              for(let i = 0; i < this.huselt.length; i++) {
                if(this.huselt[i].is_solved == 0){
                  this.countRequest = this.countRequest + 1;
                } else if(this.huselt[i].is_solved == 1) {
                  this.countRequest1 = this.countRequest1 + 1;
                }
                this.request.push(res.huselt);
              }
              this.rest.GetRequest(this.data.userId, this.date, "4").subscribe(res => {
                this.huselt = res.huselt;
                for(let i = 0; i < this.huselt.length; i++) {
                  if(this.huselt[i].is_solved == 0){
                    this.countRequest = this.countRequest + 1;
                  } else if(this.huselt[i].is_solved == 1) {
                    this.countRequest1 = this.countRequest1 + 1;
                  }
                  this.request.push(res.huselt);
                }
              });
            });
          });
        });
      // }


      if(res.amralt.length > 0){
        for(let i = 0; i < res.amralt.length; i++){
          if(res.amralt[i].begin_date <= nowdate){
            this.amraltDateCount = this.amraltDateCount + parseInt(res.amralt[i].holiday_count);
          }
        }
      }

      for (let a = 0 ; a < res.chuluu.length; a++) {
          let ch = 0;
          let ch1 = 0;
          let ch2 = 0;
          if (res.chuluu[a].end_date != res.chuluu[a].forgot_date && res.chuluu[a].is_solved == 1) {
            const date1 = new Date(res.chuluu[a].forgot_date);
            const date2 = new Date(res.chuluu[a].end_date);
            var Difference_In_Time = date2.getTime() - date1.getTime();
            this.everyMonthChuluuButenMonthStart =  Difference_In_Time / (1000 * 3600 * 24); //date2.getDate() -  date1.getDate();
            this.chuluuDateCountDay = this.chuluuDateCountDay + this.everyMonthChuluuButenMonthStart;
            var temp = date1;
            for (let i = 0; i < this.everyMonthChuluuButenMonthStart; i++) {
              if(i > 0) {
                temp.setDate(temp.getDate()+1);
              } else {
                temp.setDate(temp.getDate());
              }
              var convertTemp = temp.toISOString().substring(0,10);
              // console.log(convertTemp);
              this.AllButenChuluu.push(convertTemp);
            }
           } else if (res.chuluu[a].end_date == res.chuluu[a].forgot_date && res.chuluu[a].is_solved == 1) {
              ch++; 
              if(res.chuluu[a].forgot_date >= this.dateBegin && res.chuluu[a].end_date <= this.dateEnd) {
                this.everyMonthChuluuHagas.push(ch);
              } 
              if(res.chuluu[a].type_time == 'AM') {                
                ch1++;
                this.chuluuDateCountDayAM = this.chuluuDateCountDayAM + ch1;
              } else if(res.chuluu[a].type_time == 'PM') {  
                ch2++; 
                this.chuluuDateCountDayPM = this.chuluuDateCountDayPM + ch2;
              }
            }
      }

      for (let j = 0; j < res.times.length; j++) {
       if(res.times[j].holiday == 0) {
        this.MonthTotalDay.push(res.times[j].date);
       }
      }
      // console.log(this.MonthTotalDay)
      for (let l= 0; l< this.MonthTotalDay.length; l++) {
        let e = 0;
        for (let t= 0; t< this.AllButenChuluu.length; t++) {
          if (this.MonthTotalDay[l] == this.AllButenChuluu[t]) {
            e++;
            this.everyMonthChuluuButen.push(e);
          }
        }
      }
      this.chuluuDateCount = this.chuluuDateCount + this.everyMonthChuluuHagas.reduce((a, b) => a + b, 0)
      + this.everyMonthChuluuButen.reduce((a, b) => a + b, 0);
      if(res.year_days) {
        this.origAllDay = parseInt(res.year_days.work_day) + this.amraltDateCount + this.chuluuDateCount; 
      } else {
        this.origAllDay = this.amraltDateCount + this.chuluuDateCount;
      }
      if(res.chuluu.is_salary == "Y"){
        if(res.chuluu.forgot_date <= res.chuluu.end_date){
          res.times.startTime = res.chuluu.forgot_start_time;
          res.times.endTime = res.chuluu.forgot_time;
        } else if(res.chuluu.ttype == "AM"){
          res.times.startTime = res.chuluu.forgot_start_time;
        } else if(res.chuluu.ttype == "PM")
          res.times.endTime = res.chuluu.forgot_time;
      }
    });
  }

  setSelectdate(){
    var dateB = this.data.dateBegin;
    var dateE = this.data.dateEnd;
    for(let i = 0; i < this.Dates.length;i++) {
      if(this.Dates[i].begin_day == dateB && this.Dates[i].end_day == dateE) {
        this.date = this.Dates[i].id;
        this.data.date = this.date;
      }
    }
  }

  // formatDate(date) {

  //   var day = date.getDate();
  //   var month = date.getMonth()+1;
  //   var year = date.getFullYear();

  //   return day + '-' + month + '-' + year;
  // }

  request_sent(){
    let request_sent = this.modalCtrl.create(
      ModalContentRequestPage,
      { timecard : this.TimeCard, userId: this.data.userId },
      {
        showBackdrop: false,
        enableBackdropDismiss: true
      }
    );
    request_sent.present().catch(err => {

    });
    request_sent.onDidDismiss((data) => {
    });
  }
  
  allTime_update(){
    let allTime = this.modalCtrl.create(
      ModalContentAllTimeUpdatePage,
      { },
      {
        showBackdrop: false,
        enableBackdropDismiss: true
      }
    );    
    allTime.present().catch(err => {

    });
    allTime.onDidDismiss((data) => {
      if(data != null) {
        this.getTimeCard();
      }
    });
  }
  
  sick(){
    let sickPage = this.modalCtrl.create(
      ModalContentSickPage,
      { timecard : this.TimeCard},
      {
        showBackdrop: false,
        enableBackdropDismiss: true
      }
    );    
    sickPage.present().catch(err => {

    });
    sickPage.onDidDismiss((data) => {
      if(data != null) {
        this.getTimeCard();
      }
    });
  }

  irsenType(){
    let irsenTypePage = this.modalCtrl.create(
      ModalContentirsenTypePage,
      { type : this.data.tuluv_type },
      {
        showBackdrop: false,
        enableBackdropDismiss: true
      }
    );    
    irsenTypePage.present().catch(err => {

    });
    irsenTypePage.onDidDismiss((data) => {
      if(data != null) {
        this.getTimeCard();
      }
    });
  }

  today(){
    let now = new Date();
    let nowdate = now.getFullYear().toString() + '-' +
        ('0' + (now.getMonth() + 1).toString()).slice(-2) + '-' +
        ('0' + now.getDate().toString()).slice(-2);
    let availableDates = [];
    for(let i = 0; i < this.emptyDates.length; i++) {
      availableDates.push({date: new Date(this.emptyDates[i].substring(0,4),this.emptyDates[i].substring(5,7)-1,this.emptyDates[i].substring(8,10)), marked: true, disable: false});
    }
    let month = parseInt(('0' + (now.getMonth() + 1).toString()).slice(-2));
    let year = now.getFullYear();
    if(month > 1) {
      month--;
    } else {
      year--;
      month = 12;
    }

    const options: CalendarModalOptions = {
      pickMode: 'multi',
      title: 'Таны ирээгүй өдрүүд (улаан)',
      disableWeeks: [0, 6],
      monthFormat: 'YYYY он MM сар ',
      weekdays: ['Н', 'Д', 'М', 'Л', 'П', 'Б', 'Б'],
      weekStart: 1,
      from: new Date(year, (month - 1), 1),
      to: new Date(),
      color: 'danger',
      daysConfig: availableDates
    };
    let myCalendar =  this.modalCtrl.create(CalendarModal, {
      options: options
    });

    myCalendar.present();

    myCalendar.onDidDismiss((date: CalendarResult[], type: string) => {
    })
  }

  userRequest(){
    this.navCtrl.push(UserRequestPage);
  }

  onSelectClicked(value) {
    setTimeout(() => {
      document.getElementsByClassName('alert-radio-group')[0]
              .querySelector('[aria-checked="true"]')
              .scrollIntoView();
    }, 500);    
  }

  sendTuluv(type: any){
    const now = new Date();
    let h = '', m = '';
    if(now.getHours() < 10) {
      h = '0' + now.getHours();
    } else {
      h = now.getHours().toString();
    }
    if(now.getMinutes() < 10) {
      m = '0' + now.getMinutes();
    } else {
      m = now.getMinutes().toString();
    }
    let nowtime = h + ':' + m;
    if(!this.tuluv1) {
      if(type == 'irsen' || type == 'turgarsan' || type == 'gaduur' || type == 'butsaadirsen') {
        if(type == 'turgarsan' || type == 'gaduur') {
          document.getElementById('firstTuluv').style.visibility = 'hidden';
          document.getElementById('secondTuluv').style.visibility = 'visible';
          document.getElementById('firstTuluv').style.display = 'none';
          document.getElementById('secondTuluv').style.display = 'inline-flex';
        }
        if(type == 'butsaadirsen') {
          document.getElementById('firstTuluv').style.visibility = 'visible';
          document.getElementById('secondTuluv').style.visibility = 'hidden';
          document.getElementById('firstTuluv').style.display = 'inline-flex';
          document.getElementById('secondTuluv').style.display = 'none';
        }
        this.tuluv1 = true;                      
        if(this.startT < nowtime && this.data.userId != '45') {
          if(!this.todayStartTime) {
            this.data.tuluv_type = type;
            this.irsenType();
            this.tuluv1 = false;
          } else {
            this.showToast1('Ирсэн цаг аль хэдийн бүртгэгдсэн байна.');
          }
        } else {
          this.rest.timeBegin(this.data.userId, new Date(), type, '', '').subscribe(res => {        
            if(res.result == null) {
              this.tuluv1 = false;
              this.showToast1('Та түр хүлээнэ үү.');
            } else if(res.result) {
              if(res.msg == 'ok'){
                this.setDateSelect();
                this.getTimeCard();
                if(type == 'turgarsan' || type == 'gaduur') {
                  this.showToast('Гадуур түр гарсан цаг бүртгэгдлээ.');
                } else if(type == 'butsaadirsen') {
                  this.showToast('Буцаад ирсэн цаг бүртгэгдлээ.');
                } else {
                  this.showToast('Ирсэн цаг амжилттай бүртгэгдлээ.');
                }
              } else if(res.msg == 'already') {
                if(type == 'turgarsan' || type == 'gaduur') {
                  this.showToast1('Түр гарсан цаг аль хэдийн бүртгэгдсэн байна.');
                } else {
                  this.showToast1('Ирсэн цаг аль хэдийн бүртгэгдсэн байна.');
                }
              } else {
                this.navCtrl.push(TaskPage, {data: res.msg});
              }
              this.tuluv1 = false;
            } else {
              this.showToast1('Та зөвхөн ажил дээрээсээ цагаа хийх боломжтой.');
            }
          });       
        }
      } else if(type == 'yavsan' || type == 'yavsan2') {
        this.rest.timeEnd(this.data.userId, this.dateEnd, type, this.companyId).subscribe(res => {
          if(res.result) {
            if(res.msg == 'ok'){
              this.getTimeCard();
              this.navCtrl.push(TaskPage);
              if(parseFloat(this.data.workTime) > 8) {
                this.showToast1('Илүү цагын хүсэлтээ илгээнэ үү!!!');
              }
            } else {
              this.showToast1('Та ирсэн цагаа дараагүй байна!!!');
            }
          } else {
            this.showToast1('Та зөвхөн ажил дээрээсээ цагаа хийх боломжтой.');
          }
        });
      }
    } else {
      this.showToast1('Та түр хүлээнэ үү.');
    }
  }

  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }

  // showToast2(str: any) {
  //   let qq = '';
  //   for(let i = 0; i < this.emptyDates.length; i++) {
  //     qq = qq + this.emptyDates[i] +',  ';
  //   }        
  //   let toast = this.toastCtrl.create({
  //     message: 'Та дараах өдрүүдэд цагаа дараагүй байна. Шалгаад цагын хүсэлтээ илгээнэ үү!!!\n' + qq,
  //     position: 'middle',
  //     duration: 5000,
  //     cssClass: "toast-unsuccess"
  //   });
  //   toast.present();
  // }
  showToast2(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}

@Component({
  template: `
  <ion-header text-center style="height: 50px; text-align: center; background-color: #84dac8;">
    <ion-title>Хүсэлт илгээх</ion-title>
  </ion-header>
  <ion-content text-center>
    <ion-grid>

    <ion-row>
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
           <ion-list radio-group>
           <ion-item>
                  <ion-label floating>Хүсэлтийн төрөл</ion-label>
                  <ion-select name="request" [(ngModel)]="type" (ionChange)="setHuselt($event)">
                     <ion-option *ngFor="let request of TimeCard.time_types" value="{{request.id}}">{{request.name}}</ion-option>
                  </ion-select>
           </ion-item>
           </ion-list>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label *ngIf="type == 2 || type == 3">Эхлэх огноо</ion-label><ion-label *ngIf="type == 1 || type == 4">Огноо</ion-label>
            <ion-datetime displayFormat="YYYY-MM-DD" [(ngModel)]="sdate" (ionChange)="setTimeStart($event)"></ion-datetime>
        </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="type == 1">
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
          <p>Тоймлосон ирсэн цаг</p><input type="time" [(ngModel)]="startTime" [disabled]="isdisabled"/>
        </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>
      
      <ion-row *ngIf="type == 1">
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
          <p>Тоймлосон явсан цаг</p><input type="time" [(ngModel)]="endTime" [disabled]="isdisabled"/>
        </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="type == 1 && checkStart">
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
          <p>Ирсэн цаг</p><input type="time" class="without_ampm" [(ngModel)]="startT"/>
        </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="type == 2 || type == 3">
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label>Дуусах огноо</ion-label>
            <ion-datetime displayFormat="YYYY-MM-DD" [(ngModel)]="edate" (ionChange)="setEndTime($event)"></ion-datetime>
        </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>


      <ion-row *ngIf="type == 3">
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label>Амрах өдрүүд: {{amrahBolomjitDate}}</ion-label>
        </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="type == 2">
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label>(Чөлөө авах өдрүүд: {{chuluuBolomjitDate}})</ion-label>
        </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="type == 2 && chuluuBolomjitDate == 0">
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
        <ion-list  radio-group [(ngModel)]="ttype">
          <ion-item>
            <ion-label>AM</ion-label>
            <ion-radio value="AM" checked="true"></ion-radio>
          </ion-item>
          <ion-item>
            <ion-label>PM</ion-label>
            <ion-radio value="PM"></ion-radio>
          </ion-item>
        </ion-list>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

      <ion-row *ngIf="type == 2">
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
        <ion-list  radio-group [(ngModel)]="salary">
          <ion-item>
            <ion-label>Цалингүй</ion-label>
            <ion-radio value="N" checked="true"></ion-radio>
          </ion-item>
          <ion-item>
            <ion-label>Цалинтай</ion-label>
            <ion-radio value="Y"></ion-radio>
          </ion-item>
        </ion-list>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>


      <ion-row *ngIf="type == 1">
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
          <p>Явсан цаг</p><input type="time" class="without_ampm" [(ngModel)]="time"/>
        </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>


      <br>
      <ion-row *ngIf="type == 1">
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <button class="myButton" (click)="taskInput($event)" *ngIf="sdate != null" [disabled]="buttonDisabled">Таскны цаг оруулах</button>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

      <br>
      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label floating>Тайлбар</ion-label>
            <ion-textarea [(ngModel)]="desc"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>
      <br>
      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
          <ion-item>
            <button class="myButton" (click)="sentRequest()">Илгээх</button>
          </ion-item>
        </ion-col><ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
          <ion-item>
            <button class="myButton" (click)="backto()">Буцах</button>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>
</ion-grid>
</ion-content>
  `
})

export class  ModalContentRequestPage {
  private userId: any;
  private sdate: any;
  private edate: any;
  private type: any;
  private ttype = 'AM';
  private time = '18:00';
  private desc: any;
  private TimeCard: any;
  private time_types = [];
  private times = [];
  private data: any;
  http: any;
  private value: any;
  private startT = '09:00';
  private endT: any;
  private date: any;
  private companyId: any;
  private checkStart = false;
  private workTime = 0;
  private userTasks = [];
  private startTime: any;
  private endTime: any;
  private AFtime : any;
  private salary = 'N';
  private amrahBolomjitDate = 0;
  public chuluuBolomjitDate = 0;
  private workDay = 0;
  private isdisabled = false;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    public httpClient: HttpClient,
    private viewCtrl: ViewController,
    private toastCtrl: ToastController,
    private modalController: ModalController,)
  {
    this.TimeCard = this.navParams.get('timecard');
    this.userId = this.navParams.get('userId');

  }
  sentRequest(){
    if( !this.type ){
      this.type == null;
      this.showToast1('Хүсэлтийн төрөл сонгогдоогүй байна!!!');
      return;
    }
    if( !this.sdate ){
      this.sdate == null;
      this.showToast1('Хүсэлтийн эхлэх өдөр сонгогдоогүй байна!!!');
      return;
    }
    if(this.type == "2" || this.type == "3"){
      if( !this.edate ){
        this.edate == null;
        this.showToast1('Хүсэлтийн дуусах өдөр сонгогдоогүй байна!!!');
        return;
      }
    }
    if(this.type == "2"){
      if( !this.ttype ){
        this.ttype == null;
        this.showToast1('Хүсэлтийн өдрийн төлөв сонгогдоогүй байна!!!');
        return;
      }
    }
    if(this.type == "4"){
      if( !this.time ){
        this.time == null;
        this.showToast1('Цаг бичигдээгүй байна!!!');
        return;
      }
    }
    if( !this.desc ){
      this.desc == null;
      this.showToast1('Тайлбар бичигдээгүй байна!!!');
      return;
    }
    if(this.type == "1"){
      if( this.userTasks.length == 0){
        //this.userTasks == null;
        this.showToast1('Таскны зарцуулсан цагаа оруулна уу!!!');
        return;
      }
    }
    const now = new Date();
    let nowdate = now.getFullYear().toString() + '-' +
        ('0' + (now.getMonth() + 1).toString()).slice(-2) + '-' +
        ('0' + now.getDate().toString()).slice(-2);
    if(this.type == "1"){
      this.rest.huselt(this.userId, this.sdate, nowdate, this.type, this.ttype, this.time, this.desc, this.startT, this.userTasks, this.workTime, this.salary).subscribe(res => {
        if(res.msg == 'ok') {
          this.showToast('Хүсэлт амжилттай илгээгдлээ.');
        } else {
          this.showToast1('Хүсэлт аль хэдийн илгээгдсэн байна.');
        }
      });
    } else if(this.type == "4") {
      this.rest.huselt(this.userId, this.sdate, nowdate, this.type, this.ttype, this.time, this.desc, this.startT, this.userTasks, this.workTime, this.salary).subscribe(res => {
        if(res.msg == 'ok') {
          this.showToast('Хүсэлт амжилттай илгээгдлээ.');
        } else if(res.msg == 'already') {
          this.showToast1('Хүсэлт аль хэдийн илгээгдсэн байна.');
        } else {
          this.showToast1('Та эхлээд тухайн өдрийн цагийн хүсэлтээ илгээнэ үү. Баталгаажуулсны дараа илүү цагийн хүсэлтээ илгээнэ үү.');
        }
      });
    } else if(this.type == "2") {
      this.rest.huselt(this.userId, this.sdate, this.edate, this.type, this.ttype, this.time, this.desc, this.startT, this.userTasks, this.workTime, this.salary).subscribe(res => {
       if(res.msg == 'ok') {
          this.showToast('Хүсэлт амжилттай илгээгдлээ.');
        } else {
          this.showToast1('Хүсэлт аль хэдийн илгээгдсэн байна.');
        }
      });
    } else {
      this.rest.huselt(this.userId, this.sdate, this.edate, this.type, this.ttype, this.time, this.desc, this.startT, this.userTasks, this.workTime, this.salary).subscribe(res => {
        if(res.msg == 'ok') {
          this.showToast('Хүсэлт амжилттай илгээгдлээ.');
        } else if(res.msg == 'already') {
          this.showToast1('Хүсэлт аль хэдийн илгээгдсэн байна.');
        } else {
          this.showToast1('Та эхлээд тухайн өдрийн цагийн хүсэлтээ илгээнэ үү. Баталгаажуулсны дараа илүү цагийн хүсэлтээ илгээнэ үү.');
        }
      });
    }

    this.viewCtrl.dismiss({});
  }

  backto(){
    this.viewCtrl.dismiss({});
  }
  setTimeStart(event){
    this.workDay = 0;
    let checkDate = false;
    this.isdisabled = true;
    for(let i = 0; i < this.TimeCard.times.length; i++){
      if(this.TimeCard.times[i].date == this.sdate){
        this.startTime = this.TimeCard.times[i].toimStartTime;
        this.endTime = this.TimeCard.times[i].toimEndTime;
        if(this.TimeCard.times[i].startTime == null){
          this.checkStart = true;
        }
        if(this.TimeCard.times[i].startTime != null){
          if(this.startTime > '09:15'){
            this.checkStart = true;
          } else if(this.startTime <= '09:00') {
            this.startTime = this.TimeCard.times[i].startTime;
            this.checkStart = false;
          }
        }
        checkDate = true;
      }
    }
    if(!checkDate && this.type == 1) {
      this.showToast1('Таны хүсэлт гаргах огноо энэ сардаа багтаагүй байна. Зөв сонгоно уу.');
      this.viewCtrl.dismiss({});
    }
    if(this.type == "3"){
      if(this.sdate != null || this.edate != null || this.sdate != this.edate){
        for(this.sdate; this.sdate < this.edate; this.sdate++){
          for(let i = 0; i < this.TimeCard.times.length; i++) {
            if(this.TimeCard.times[i].holiday == 0 || this.TimeCard.times.date == this.sdate || this.TimeCard.times.date == this.edate) {
              this.workDay++;
            }
          }
        }
      }
      if(this.sdate != null && this.edate != null) {
        this.getAmralt();
      }
    }
  }

  setEndTime(date: any) {
    if(this.sdate != null && this.edate != null) {
      if(this.type == 3) {
        this.getAmralt();
      }
      if(this.type == 2) {
        var date1 = new Date(this.sdate);
        var date2 = new Date(this.edate); 
        var Difference_In_Time = date2.getTime() - date1.getTime();
        this.chuluuBolomjitDate = Difference_In_Time / (1000 * 3600 * 24);
      }
    }
  }

  getAmralt() {
    this.amrahBolomjitDate = 0;
    this.rest.getAmraltCount(this.sdate, this.edate).subscribe(res => {
      this.amrahBolomjitDate = res.count;
    });
  }

  setHuselt(event: any){
    this.type = event;
  }


  taskInput($event){
    if(this.sdate != null){
      $event.buttonDisabled = true;
    }
    //this.workTime = '8';
    if(this.checkStart) {
      var timeStart = new Date("2020-01-01 " + this.startT + ':00').getTime();
      var timeEnd = new Date("2020-01-01 " + this.time + ':00').getTime();
      var hourDiff = timeEnd - timeStart;
      let hr = hourDiff/1000/60 |0;
      let h = hr/60 |0;
      let m = hr%60;
      if(m < 15) {
        m = 0;
      } else if(m < 30) {
        m = 0.25
      } else if(m < 45) {
        m = 0.5;
      } else {
        m = 0.75
      }
        this.workTime =  h - 1 + m;
    //  this.workTime = parseInt(this.time) - parseInt(this.startT) - 1;
    } else {
      timeStart = new Date("2020-01-01 " + this.startTime).getTime();
      timeEnd = new Date("2020-01-01 " + this.time + ':00').getTime();
      hourDiff = timeEnd - timeStart;
      let hr = hourDiff/1000/60 | 0;
      let h = hr/60 | 0;
      let m = hr%60;
      if(m < 15) {
        m = 0;
      } else if(m < 30) {
        m = 0.25
      } else if(m < 45) {
        m = 0.5;
      } else {
        m = 0.75
      }
      this.workTime =  h - 1 + m;
      // this.workTime = parseInt(this.time) - parseInt(this.startTime) - 1;
    }
    if(this.workTime < 0) {
      this.isdisabled = true;
      this.showToast1('Алдаа гарлаа. Хуудсаа шинэчлээд дахин оролдоно уу!!!');
      this.viewCtrl.dismiss({});
      this.navCtrl.push(DashboardPage);
    } else if(this.workTime > 0) {
      let taskInput = this.modalController.create(
        TaskPage,
        { type: 'huselt', workTime: this.workTime },
        {
          showBackdrop: false,
          enableBackdropDismiss: false
        }
      );
      taskInput.present().catch(err => {

      });
      taskInput.onDidDismiss((data) => {
        this.userTasks = data.data;
      });
    }
  }
  
  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }

  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}

@Component({
  template: `
  <ion-header text-center style="height: 50px; text-align: center; background-color: #84dac8;">
    <ion-title>Сараар цаг өөрчлөх</ion-title>
  </ion-header>
  <ion-content text-center>
    <ion-grid style="margin-top: 100px;">

      <ion-row>
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
          <p>Ирсэн цаг</p><input type="time" class="without_ampm" [(ngModel)]="startT"/>
        </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>
      
      <ion-row>
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
      </ion-col>
      <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
        <ion-item>
        <p>Явсан цаг</p><input type="time" class="without_ampm" [(ngModel)]="time"/>
      </ion-item>
      </ion-col>
      <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
      </ion-col>
    </ion-row>

      <br>
      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
          <ion-item>
            <button class="myButton" (click)="sentRequest()">Өөрчлөх</button>
          </ion-item>
        </ion-col><ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
          <ion-item>
            <button class="myButton" (click)="backto()">Буцах</button>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>
</ion-grid>
</ion-content>
  `
})

export class  ModalContentAllTimeUpdatePage {
  private userId: any;
  private sdate: any;
  private edate: any;
  private type: any;
  private ttype = 'AM';
  private time = '18:00';
  private desc: any;
  private TimeCard: any;
  private startT = '09:00';
  private companyId: any;
  private date: any;
  
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    public httpClient: HttpClient,
    private viewCtrl: ViewController,
    private toastCtrl: ToastController,
    private modalController: ModalController,
    private data: DataProvider,
    public app: App)
  {
    // this.TimeCard = this.navParams.get('timecard');
    this.userId = this.data.userIditem;
    this.companyId = this.data.companyId;
    this.date = this.data.date;
  }
  sentRequest(){
    this.rest.monthTimeAgree(this.userId, this.companyId, this.date, this.startT, this.time).subscribe(res => {
      if(res.msg == 'ok') {
        this.showToast('Таны сонгосон ажилтаны тухайн сарын ажилласан цагууд амжилттай өөрчлөгдлөө.');
      } else {
        this.showToast1('Өөрчлөлт аль хэдийн хийгдсэн байна.');
      }
    });
    this.viewCtrl.dismiss({});
    // let nav = this.app.getRootNavs();
    // nav[0].setRoot(DashboardPage);
  }

  backto(){
    this.viewCtrl.dismiss({});
  }
  
  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }

  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}


export class  CalendarModalPage {
  public userId: any;
  public date: any;
  public companyId: any;
  private TimeCard = [];
  private empty_dates = [];
  public weekdays = [];

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    public httpClient: HttpClient,
    private viewCtrl: ViewController,
    private toastCtrl: ToastController)
  {
    this.TimeCard = this.navParams.get('timecard');
    this.userId = this.navParams.get('userId');
  }
  getEmptyDates() {
    this.rest.TimeCard(this.userId, this.date, this.companyId).subscribe(res => {
    });
  }
}

@Component({
  template: `
  <ion-header text-center style="height: 50px; text-align: center; background-color: #84dac8;">
    <ion-title>Ажилтаны өвчтэй өдөр оруулах хэсэг</ion-title>
  </ion-header>
  <ion-content text-center>
    <ion-grid>
      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label>Эхлэх огноо</ion-label>
            <ion-datetime displayFormat="YYYY-MM-DD" [(ngModel)]="sdate"></ion-datetime>
        </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label>Дуусах огноо</ion-label>
            <ion-datetime displayFormat="YYYY-MM-DD" [(ngModel)]="edate"></ion-datetime>
        </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>


      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
          <ion-item>
            <button class="myButton" (click)="sentRequest()">Илгээх</button>
          </ion-item>
        </ion-col><ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
          <ion-item>
            <button class="myButton" (click)="backto()">Буцах</button>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>
</ion-grid>
</ion-content>
  `
})

export class  ModalContentSickPage {
  private userId: any;
  private sdate: any;
  private edate: any;
  private TimeCard: any;
  private times = [];
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    public httpClient: HttpClient,
    private viewCtrl: ViewController,
    private toastCtrl: ToastController,
    private modalController: ModalController,
    private data: DataProvider)
  {
    this.TimeCard = this.navParams.get('timecard'); 
    this.userId = this.data.userIditem;

  }
  sentRequest(){
    let checkDate = false;
    for(let i = 0; i < this.TimeCard.times.length; i++){
      if(this.TimeCard.times[i].date == this.sdate){
        checkDate = true;
      }
    }
    if(!checkDate) {
      this.showToast1('Огноо энэ сардаа багтаагүй байна. Зөв сонгоно уу.');
      this.viewCtrl.dismiss({});
    } else {
      if( !this.sdate ){
        this.sdate == null;
        this.showToast1('Эхлэх өдөр сонгогдоогүй байна!!!');
        return;
      }if( !this.edate ){
        this.edate == null;
        this.showToast1('Дуусах өдөр сонгогдоогүй байна!!!');
        return;
      }
      if(this.sdate != null || this.edate != null){
        this.rest.setUserSick(this.userId, this.sdate, this.edate).subscribe(res => {
          if(res.msg == 'ok') {
            this.showToast('Ажилтаны өвчтэй өдөр амжилттай оруулаа.');
          } 
        });
        this.viewCtrl.dismiss({});
      }
    }
  }

  backto(){
    this.viewCtrl.dismiss({});
  }
  
  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }

  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}



@Component({
  template: `
  <ion-header text-center style="height: 50px; text-align: center; background-color: #84dac8;">
    <ion-title>Хоцорсон шалтгаан оруулах хэсэг</ion-title>
  </ion-header>
  <ion-content text-center>
    <ion-grid>
      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <div col-12 col-sm-12 col-md-12 style="padding-left:5%; width: 100%" class="center label-md">
            <ion-item>
              <ion-select name="Reason" [(ngModel)]="reason" (ionChange)="setReason($event)" class="border1" style="width: 100%;text-transform: uppercase;"
              (click)="onSelectClicked($event)" placeholder="Шалтгаан сонго">
                <ion-option value="Шалтгаангүй">Шалтгаангүй</ion-option>
                <ion-option value="Эмнэлэг орсон">Эмнэлэг орсон</ion-option>
                <ion-option value="Удирдлагад хэлсэн">Удирдлагад хэлсэн</ion-option>
              </ion-select>
            </ion-item>
          </div>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
          <ion-item>
            <ion-label floating>Тайлбар</ion-label>
            <ion-textarea [(ngModel)]="desc"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>


      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
        <ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
          <ion-item>
            <button class="myButton" (click)="sentRequest()">Илгээх</button>
          </ion-item>
        </ion-col><ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
          <ion-item>
            <button class="myButton" (click)="backto()">Буцах</button>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
        </ion-col>
      </ion-row>
</ion-grid>
</ion-content>
  `
})

export class  ModalContentirsenTypePage {
  // private userId: any;
  private reason: any;
  private desc: any;
  type: any;
  private tuluv1 = false;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    public httpClient: HttpClient,
    private viewCtrl: ViewController,
    private toastCtrl: ToastController,
    private modalController: ModalController,
    private data: DataProvider)
  {
    this.type = this.navParams.get('type');
  }

  onSelectClicked(value) {
    // setTimeout(() => {
    //   document.getElementsByClassName('alert-radio-group')[0]
    //           .querySelector('[aria-checked="true"]')
    //           .scrollIntoView();
    // }, 500);    
  }

  
  setReason(event: any){
    this.reason = event;
  }
  
  sentRequest(){
    if( !this.reason ){
      this.reason == null;
      this.showToast1('Шалтгаан сонгогдоогүй байна!!!');
      return;
    }
    if( !this.desc ){
      this.desc == null;
      this.showToast1('Тайлбар бичигдээгүй байна!!!');
      return;
    }
    this.rest.timeBegin(this.data.userId, new Date(), this.type, this.reason, this.desc).subscribe(res => {          
      if(res.result == null) {
        this.tuluv1 = false;
        this.showToast1('Та түр хүлээнэ үү.');
      } else if(res.result) {
        if(res.msg == 'ok'){
          if(this.type == 'turgarsan' || this.type == 'gaduur') {
            this.showToast('Гадуур түр гарсан цаг бүртгэгдлээ.');
          } else if(this.type == 'butsaadirsen') {
            this.showToast('Буцаад ирсэн цаг бүртгэгдлээ.');
          } else {
            this.showToast('Ирсэн цаг амжилттай бүртгэгдлээ.');
          }
        } else if(res.msg == 'already') {
          if(this.type == 'turgarsan' || this.type == 'gaduur') {
            this.showToast1('Түр гарсан цаг аль хэдийн бүртгэгдсэн байна.');
          } else {
            this.showToast1('Ирсэн цаг аль хэдийн бүртгэгдсэн байна.');
          }
        } else {
          this.navCtrl.push(TaskPage, {data: res.msg});
        }
        this.tuluv1 = false;
      } else {
        this.showToast1('Та зөвхөн ажил дээрээсээ цагаа хийх боломжтой.');
      }
    });

    this.viewCtrl.dismiss({});
  }

  backto(){
    this.viewCtrl.dismiss({});
  }
  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }

  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.ts